import { DEFAULT_LOCALE, type Locale, SUPPORTED_LOCALES } from './localeConstants';

export const detectLocale = (): Locale => {
  const browserLang = navigator.language;

  if (SUPPORTED_LOCALES.includes(browserLang as Locale)) {
    return browserLang as Locale;
  }

  const browserPrimaryLang = browserLang?.split('-')[0];
  // Order in SUPPORTED_LOCALES determines which locale wins when multiple share a primary tag.
  const matched = SUPPORTED_LOCALES.find((locale) => locale.split('-')[0] === browserPrimaryLang);

  return matched ?? DEFAULT_LOCALE;
};
